import axios from "axios";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate, useParams } from "react-router-dom";
import RealMatch from "./QuestionTypes/RealMatch"
import VideoContent from "./QuestionTypes/VideoContent"
import Choice from "./QuestionTypes/Choice"
import Write from "./QuestionTypes/Write";
import Match from "./QuestionTypes/Match";
import TrueFalse from "./QuestionTypes/TrueFalse";
import Sentence from "./QuestionTypes/Sentence";
import Pagination from "./QuestionTypes/Pagination";
import Link from "./QuestionTypes/Link";

import { LayoutContext } from "../../DashboardLayout";

export const UserQuestion = () => {
    const params = useParams();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataa, setDataa] = useState([]);
    const [questionType, setquestionType] = useState([]);
    const [questionCount, setquestionCount] = useState([]);
    const [questionNumber, setquestionNumber] = useState([]);
    const [truefalseanswercount, settruefalseanswercount] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [answered, setAnswered] = useState(false);
    const [realAnswer, setrealAnswer] = useState("");
    const [color, setColor] = useState("");
    const [subjectId, setSubjectId] = useState("");
    const [realAnswers, setRealAnswers] = useState([]);

    const [paginationAnswers, setpaginationAnswers] = useState([]);
    const { setContentStyle } = useContext(LayoutContext);

    const navigate = useNavigate();
    const successAudioRef = useRef(null);
    const errorAudioRef = useRef(null);

    const playSuccessSound = () => {
        if (successAudioRef.current) {
            successAudioRef.current.currentTime = 0;
            successAudioRef.current.play().catch(() => { });
        }
    };

    const playErrorSound = () => {
        if (errorAudioRef.current) {
            errorAudioRef.current.currentTime = 0;
            errorAudioRef.current.play().catch(() => { });
        }
    };
    useEffect(() => {
        successAudioRef.current = new Audio("https://api.heryerdeingilizce.com/sound/624c0620-d97e-46ba-8f03-3748bd1ed1af.mp4");
        errorAudioRef.current = new Audio("https://api.heryerdeingilizce.com/sound/ca04bbe0-aff6-45c3-8976-b9c6ea031dc8.mp4");

        successAudioRef.current.preload = "auto";
        errorAudioRef.current.preload = "auto";

        successAudioRef.current.load();
        errorAudioRef.current.load();
    }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            document.body.style.overflow = "auto";
        }

        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    // 1) SUBJECT ID GETİR
    useEffect(() => {
        const getSubjectId = async () => {
            try {
                // const res = await axios.get(
                //     "https://api.heryerdeingilizce.com/api/user/Content/GetSubject",
                //     {
                //         headers: { Authorization: "Bearer " + user.token }
                //     }
                // );
                const res = await axios.get(
                    "https://api.heryerdeingilizce.com/api/user/Content/GetSubject",
                    {
                        headers: { Authorization: "Bearer " + user.token },
                        params: { courseId: params.courseid }
                    }
                );
                console.log("Subject Data:", res.data)
                if (res.data.success) {
                    const found = res.data.data.subjects.find(
                        (s) => Number(s.sortId) === Number(params.subjectid)
                    );
                    console.log("Found Subject:", found)
                    if (found) setSubjectId(found.id);
                }
            } catch (err) {
                console.log(err);
            }
        };

        getSubjectId();
    }, [params.subjectid]);

    // 2) SUBJECT ID GELİNCE RENK GETİR
    useEffect(() => {
        if (!subjectId) return;

        const getColor = async () => {
            try {
                const renkdata = await axios.get(
                    "https://express.heryerdeingilizce.com/getsubjectcolourbyid/" +
                    subjectId
                );
                setColor(renkdata.data[0].colourcode);
            } catch (err) {
                setMsg(err);
            }
        };

        getColor();
    }, [subjectId]);

    // 3) COLOR GELİNCE ARKAPLAN GÜNCELLE
    useEffect(() => {
        if (color) {
            setContentStyle({ backgroundColor: color });
        }
    }, [color]);

    /**
     * ✅ NESTED STRUCTURE İÇİN CHECK
     * realAnswers: courses -> subjects -> answers
     */
    const checkAnswered = (questionId) => {
        let found = null;

        realAnswers.forEach(course => {
            course.subjects.forEach(subject => {
                subject.answers.forEach(answerItem => {
                    if (Number(answerItem.questionId) === Number(questionId)) {
                        found = answerItem;
                    }
                });
            });
        });

        if (found) {
            setAnswered(true);
            setrealAnswer(found.isTrue ? "Doğru" : "Yanlış");
        } else {
            setAnswered(false);
            setrealAnswer("");
        }
    };

    /**
     * ✅ pagination için aynı mantık
     */
    const getAnswerInfo = (questionId) => {
        let found = null;

        realAnswers.forEach(course => {
            course.subjects.forEach(subject => {
                subject.answers.forEach(answerItem => {
                    if (Number(answerItem.questionId) === Number(questionId)) {
                        found = answerItem;
                    }
                });
            });
        });

        return {
            answered: !!found,
            answerCorrect: found ? !!found.isTrue : false
        };
    };

    useEffect(() => {
        setAnswered(false);
        const report = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                let url = "https://api.heryerdeingilizce.com/api/user/Opt/MyReport";
                //let url = "https://localhost:7004/api/user/Opt/MyReport";

                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            setRealAnswers(res.data['data'] || []);
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }



        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }

                let url = "https://api.heryerdeingilizce.com/api/user/Content/GetContent";
                //let url = "https://localhost:7004/api/user/Content/GetContent";
                await axios({
                    method: 'GET',
                    url: url,
                    params: {
                        courseId: params["courseid"],
                        sortId: params["subjectid"]
                    },
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            setquestionCount(res.data['data']['contents'].length);

                            if (Number(params["id"]) > res.data['data']['contents'].length) {
                                navigate("/user/course/subject/" + params["courseid"]);
                            }
                            else {

                                setquestionNumber(res.data['data']['contents'][Number(params['id']) - 1]['id']);
                                let realData = res.data['data']['contents'][Number(params['id']) - 1];
                                setDataa(realData);

                                let questionId = res.data['data']['contents'][Number(params['id']) - 1]['id'];

                                // ✅ önce checkAnswered (nested)
                                checkAnswered(questionId);

                                // ✅ SENİN İSTEDİĞİN FOR BLOĞU DURUYOR
                                // ama içi nested çalışıyor
                                for (let a = 0; a < realAnswers.length; a++) {
                                    const course = realAnswers[a];
                                    course.subjects.forEach(subject => {
                                        subject.answers.forEach(answerItem => {
                                            if (Number(answerItem.questionId) === Number(questionId)) {
                                                setAnswered(true);
                                                setrealAnswer(answerItem.isTrue ? "Doğru" : "Yanlış");
                                            }
                                        });
                                    });
                                }

                                const tempPagination = [];

                                if (res.data['data']['contents'].length !== 0) {
                                    for (let i = 0; i < res.data['data']['contents'].length; i++) {

                                        let num = Number(i) + 1;
                                        let activity = false;

                                        if (Number(params['id'] - 1) === Number(i)) {
                                            activity = true;
                                        }

                                        // ✅ pagination için nested cevap kontrolü
                                        const info = getAnswerInfo(res.data['data']['contents'][i]['id']);

                                        tempPagination.push(
                                            {
                                                "id": i + 1,
                                                "href": "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + num.toString(),
                                                "isActive": activity,
                                                "answered": info.answered,
                                                "answerCorrect": info.answerCorrect
                                            }
                                        )
                                    }
                                }

                                setPagination(tempPagination);

                                setquestionType(res.data['data']['contents'][Number(params['id']) - 1]['contentType']);
                                setAnswer(res.data['data']['contents'][Number(params['id']) - 1]['answer']);

                                let x = JSON.parse(realData['detail']);
                                settruefalseanswercount(x.length);
                            }

                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        // ✅ fetchdata mutlaka reporttan sonra gelirse iyi olur
        // ama useEffect sayısını değiştirmiyoruz diye burada koşullu yürütüyoruz:
        const run = async () => {
            await report();
            await fetchdata();
        };

        run();
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };

    }, [params.id, params.subjectid, realAnswers.length]);

    if (!loading) {
        if (questionType === 'video') {
            return (
                <div style={{ position: "relative" }}>
                    <VideoContent data={dataa} questionCount={questionCount} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div>
            )
        }
        else if (questionType === 'write') {
            return (
                <div style={{ position: "relative" }}>
                    <Write data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'choice') {
            return (
                <div style={{ position: "relative" }}>
                    <Choice data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'match') {
            return (
                <div style={{ position: "relative" }}>
                    <Match data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'truefalse') {
            return (
                <div style={{ position: "relative" }}>
                    <TrueFalse data={dataa} truefalseanswercount={truefalseanswercount} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'realmatch') {
            return (
                <div style={{ position: "relative" }}>
                    <RealMatch
                        data={dataa}
                        questionNumber={questionNumber}
                        answer={answer}
                        answered={answered}
                        realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound}
                    />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'sentence') {
            return (
                <div style={{ position: "relative" }}>
                    <Sentence data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />
                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
        else if (questionType === 'link') {
            return (
                <div style={{ position: "relative" }}>
                    <Link data={dataa} questionNumber={questionNumber} answer={answer} answered={answered} realanswer={realAnswer}
                        playSuccessSound={playSuccessSound}
                        playErrorSound={playErrorSound} />

                    {!loading && (
                        <Pagination pagination={pagination} />
                    )}
                </div >
            )
        }
    }

    return <div>Yükleniyor...</div>;
}
export default UserQuestion;
